import script from "./StepFour.vue?vue&type=script&setup=true&lang=ts"
export * from "./StepFour.vue?vue&type=script&setup=true&lang=ts"

import "./StepFour.vue?vue&type=style&index=0&id=14427763&lang=scss"

const __exports__ = script;

export default __exports__